import React from 'react';

/** Real photo, identity and selection rail are independent planes. CSS owns bounded motion. */
export default function BuildDossierHero({
  media,
  masthead,
  titleFirst,
}: {
  media: React.ReactNode;
  masthead: React.ReactNode;
  titleFirst: boolean;
}) {
  return (
    <section
      className="build-dossier-hero duo-surface"
      aria-label="Build photographs and identity"
      data-title-first={titleFirst || undefined}
    >
      <div className="build-dossier-hero__identity">{masthead}</div>
      <div className="build-dossier-hero__media">{media}</div>
      <span className="build-dossier-hero__edge" aria-hidden />
    </section>
  );
}
